import { PageRef } from 'providers/page-ref';

export type AdminKeygenPageParams = {};

export const IAdminKeygenPage: PageRef<AdminKeygenPageParams, void> = {
  pageName: 'AdminKeygenPage',
} as PageRef<AdminKeygenPageParams, void>;
